import { ReactElement, forwardRef } from 'react'

import { useClickOutside } from '@/hooks/useClickOutside'

import * as S from './styles'

type Props = {
  children?: ReactElement | string
  className?: string
  onClose?: () => void
  hasHeader?: boolean
  maxWidth?: string
}

const Dialog = forwardRef<HTMLDivElement, Props>(
  (
    { children, className = '', onClose, hasHeader = false, maxWidth, ...rest },
    ref
  ) => {
    useClickOutside({
      elementRef: ref,
      clickOutsideFunction: onClose,
    })

    return (
      <S.Content
        className={className}
        ref={ref}
        role="dialog"
        aria-modal="true"
        hasHeader={hasHeader}
        maxWidth={maxWidth}
        {...rest}
      >
        {children}
      </S.Content>
    )
  }
)

Dialog.displayName = 'Dialog'

export default Dialog
